import classNames from 'classnames';
import uniqueId from 'lodash/uniqueId';
import * as React from 'react';
import { useTheme } from '~/Features/Layouts/Theme/Context/ThemeContextProvider';
import styles from './Dropdown.module.css';

export interface DropdownProps {
    options: DropdownItem[];
    onValueChanged: (value: string) => void;
    placeholder?: string;
    label?: string;
    selectedValue?: string;
    className?: string;
    disabled?: boolean;
    errorMessage?: string;
    disableArrow?: boolean;
}

export interface DropdownItem {
    value: string;
    text: string;
    className?: string;
}

export const Dropdown = (props: DropdownProps) => {
    const {
        selectedValue,
        onValueChanged,
        options,
        label,
        placeholder,
        errorMessage,
        disabled,
        disableArrow,
        className,
    } = props;

    const { withRoundedCorners, withBoxShadow } = useTheme();

    const makeOption = (item: DropdownItem, index: number) => (
        <option key={`${item.value}_${index}`} value={item.value} className={item.className}>
            {item.text}
        </option>
    );

    const handleValueChanged = (e: React.ChangeEvent<HTMLSelectElement>) => {
        onValueChanged(e.target.value);
    };

    const id = uniqueId('Form__dropdown__');

    return (
        <div
            className={classNames(
                disabled && styles['Variant--disabled'],
                withRoundedCorners && styles['Variant--rounded'],
                withBoxShadow && styles['Variant--shadowed'],
                disableArrow && styles['Variant--withoutArrow'],
                className
            )}
        >
            {label && (
                <label htmlFor={id} className={styles.Label}>
                    {label}
                </label>
            )}
            <div className={styles.Select}>
                <select
                    value={selectedValue || undefined}
                    defaultValue=""
                    onChange={handleValueChanged}
                    disabled={disabled}
                    id={id}
                >
                    {placeholder && (
                        <option key="placeholder" value="" disabled hidden>
                            {placeholder}
                        </option>
                    )}
                    {options.map(makeOption)}
                </select>
            </div>
            {!!errorMessage && <span className="Form__errorMessage">{errorMessage}</span>}
        </div>
    );
};
